__turbopack_context__.v({
  "arrow-next": "SectionMainCarousel-module-sass-module__3NUc5W__arrow-next",
  "arrow-prev": "SectionMainCarousel-module-sass-module__3NUc5W__arrow-prev",
  "controls": "SectionMainCarousel-module-sass-module__3NUc5W__controls",
  "slider": "SectionMainCarousel-module-sass-module__3NUc5W__slider",
  "wrapper": "SectionMainCarousel-module-sass-module__3NUc5W__wrapper",
});
